import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Panel from '../Panel';
import { isDarkTheme } from '../../helpers/themeTableStyles';

const PercentOf = ({
  content, loadingData, lgWidth, color,
}) => {
  const theme = useSelector(store => store.theme);
  const isDarkMode = isDarkTheme(theme);

  const textStyle = {
    color: isDarkMode ? '#dddddd' : '#646777',
  };

  const boxStyle = {
    backgroundColor: isDarkMode ? '#232329' : 'transparent',
  };

  return (
    <Panel md={12} lg={lgWidth} title={content.title} parentRefresh={loadingData} color={color}>
      <div className="dashboard__sales-report" style={boxStyle}>
        <div className="progress-wrap progress-wrap--small" style={boxStyle}>
          <p className="dashboard__sales-report-title">{content.left_header}</p>
          <p className="dashboard__bypage-chart-number" style={textStyle}>{content.left_data}</p>
        </div>
        <div className="progress-wrap progress-wrap--small progress-wrap--pink" style={boxStyle}>
          <p className="dashboard__sales-report-title">{content.middle_header}</p>
          <p className="dashboard__bypage-chart-number" style={{ ...textStyle, whiteSpace: 'nowrap' }}>{content.middle_data}</p>
        </div>
        <div className="progress-wrap progress-wrap--small progress-wrap--pink" style={boxStyle}>
          <p className="dashboard__sales-report-title">{content.right_header}</p>
          <p className="dashboard__bypage-chart-number" style={textStyle}>{content.right_data}</p>
        </div>
      </div>
    </Panel>
  );
};

PercentOf.defaultProps = {
  lgWidth: 6,
  color: '',
};

PercentOf.propTypes = {
  // eslint-disable-next-line
  content: PropTypes.object.isRequired,
  loadingData: PropTypes.bool.isRequired,
  lgWidth: PropTypes.number,
  color: PropTypes.string,
};

export default PercentOf;
